module.exports = __webpack_public_path__ + "img/SAS_BastardSword.576b264e.png";